import React, { useEffect, useState } from "react";
import style from "./user.module.css";
import profile from "../../../Assets/newProfile.svg";
import edit from "../../../Assets/edit3.svg";
import password from "../../../Assets/password.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { recruiterActions, studentActions } from "../../../redux/actions";
import BackIcon from "../../../Assets/BackIcon.svg";
const Userprofile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const students = useSelector((state) => state.student);
  const recruiter = useSelector((state) => state?.recruiter?.data);
  const [user, setUser] = useState("");

  const sliceText = (text) => {
    if (text.length >= 14) {
      const sliced = text.slice(0, 15);
      return `${sliced}...`;
    }
    return text;
  };

  const sliceText1 = (text) => {
    if (text.length >= 10) {
      const sliced = text.slice(0, 11);
      return `${sliced}...`;
    }
    return text;
  };
  useEffect(() => {
    const locationEndpoint = location.pathname.split("/");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user._id;
    if (locationEndpoint[2] === "recruiter") {
      dispatch(recruiterActions.setRecruiter(userId)).then((_) => {
        setUser("recruiter");
      });
    } else {
      dispatch(studentActions.setStudent(userId)).then((_) => {
        setUser("student");
      });
    }
  }, [location]);

  // console.log(recruiter);

  if (!user) {
    return <div>Loading...</div>;
  }

  if (user === "student") {
    return (
      <div className={style.container}>
        <div className={style.profileTxt}>
          <div
            onClick={() => navigate(-1, { replace: true })}
            className={style.back}
          >
            <img src={BackIcon} alt="" />
          </div>
          <div>Profile</div>
        </div>
        <div className={style.profilecont}>
          <div className={style.profileemailName}>
            <div className={style.userprofile}>
              <img src={students.profilePhoto || profile} alt="userprofile" />
            </div>
            <div className={style.nameEmail}>
              <div className={style.userName}>
                <div className={style.userTxt}>User name</div>
                <div className={style.usernameTxt}>
                  {students?.name ? sliceText1(students?.name) : ""}
                </div>
              </div>
              <div className={style.userName}>
                <div className={style.userTxt}>Email ID</div>
                <div className={style.usernameTxt}>
                  {students?.email ? sliceText(students?.email) : ""}
                </div>
              </div>
            </div>
          </div>
          <div
            className={style.editBtn}
            onClick={() => navigate(`/hiring/student/Editprofile`)}
          >
            <img src={edit} alt="" />

            <button>Edit</button>
          </div>
        </div>
        <div className={style.passwordstatus}>
          <div className={style.passworIcon}>
            {/* <div className={style.passIcon}>
              <img src={password} alt="" />
            </div> */}
            <div className={style.password}>Password</div>
          </div>
          <div
            className={style.changepassword}
            onClick={() => navigate("/hiring/student/change_password")}
          >
            Change password
          </div>
        </div>
        <div className={style.passwordstatus1}>
          <div className={style.passworIcon}>
            <div className={`${style.password}${style.password1}`}>Status</div>
          </div>
          <div className={style.changepassword1}>
            <select
              name=""
              id=""
              className={style.openwork}
              value={students?.student_status}
              onChange={(e) =>
                dispatch(studentActions.changeStudentStatus(e.target.value))
              }
            >
              <option value="open_for_work">Open for Work</option>
              <option value="browsing">Casually Browsing</option>
              <option value="not_looking">Not Looking</option>
            </select>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={style.container}>
      <div className={style.profileTxt}>Profile</div>
      <div className={style.profilecont}>
        <div className={style.profileemailName}>
          <div className={style.userprofile}>
            <img src={recruiter.profilePhoto || profile} alt="userprofile" />
          </div>
          <div className={style.nameEmail}>
            <div className={style.userName}>
              <div className={style.userTxt}>User Name</div>
              <div className={style.usernameTxt}>{recruiter?.name}</div>
            </div>
            <div className={style.userName}>
              <div className={style.userTxt}>User Email</div>
              <div className={style.usernameTxt}>{recruiter?.email}</div>
            </div>
          </div>
        </div>
        <div
          className={style.editBtn}
          onClick={() => navigate(`/hiring/recruiter/Editprofile`)}
        >
          <img src={edit} alt="" />

          <button>Edit</button>
        </div>
      </div>
      <div className={style.passwordstatus}>
        <div className={style.passworIcon}>
          {/* <div className={style.passIcon}>
            <img src={password} alt="" />
          </div> */}
          <div className={style.password}>Password</div>
        </div>
        <div
          className={style.changepassword}
          onClick={() => navigate("/hiring/recruiter/change_password")}
        >
          Change password
        </div>
      </div>
      <div
        className={`${style.passwordstatus} ${style.mobileonly}`}
        style={{
          borderTop: "none",
          marginTop: 0,
        }}
      >
        <div className={style.status} style={{ textAlign: "start" }}>
          <p style={{ fontSize: "12px" }}>Company</p>
          <p style={{ fontWeight: "bold" }}>{recruiter?.companyName}</p>
        </div>
        <div style={{ paddingRight: "3%" }}>
          <div
            className={style.changepass}
            style={{ fontSize: "1.2rem", cursor: "pointer" }}
            onClick={() => {
              navigate(
                `/hiring/recruiter/manageCompany/${recruiter?.companyId}`
              );
            }}
          >
            Manage Company
          </div>
        </div>
      </div>
    </div>
  );
};

export default Userprofile;
